import { datadogRum } from '@datadog/browser-rum';

// Depends on DD_RUM_CONFIG being set in the global scope.
// This is done in the theme.liquid file.
if ('DD_RUM_CONFIG' in window) {
  // console.log('Initializing DataDog RUM', window.DD_RUM_CONFIG);
  datadogRum.init(window.DD_RUM_CONFIG);
}
